import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { isBrokerAccountSelector } from "selectors-lib/linkedAccounts"
import { getToken } from "actions-lib/getToken"
import { refreshToken } from "actions-lib/refreshToken"
import { resetUserAccount } from "actions-lib/resetUserAccount"
import { revokeToken } from "actions-lib/revokeToken"
import { setLastActivityTime } from "actions-lib/setLastActivityTime"
import { setSessionIntervalId } from "actions-lib/setSessionIntervalId"
import { setToken } from "actions-lib/setToken"
import { getUserDetails } from "actions-lib/getUserDetails"
import { getUserAccountBalance } from "actions-lib/getUserAccountBalance"
import { getLinkedAccounts } from "actions-lib/getLinkedAccounts"
import {
  getAllCustomer,
  getUserPaymentDetails,
} from "actions-lib/getUserPaymentDetails"
import { setUserDetails } from "actions-lib/setUserDetails"
import { setUserState } from "actions-lib/setUserState"
import { setSelectedCurrency } from "actions-lib/setSelectedCurrency"
import { resetCartDetails } from "actions-lib/getCartDetails"
import { switchLanguage } from "actions-lib/setLanguage"
import { getGlobalAlerts } from "actions-lib/getGlobalAlerts"
import { getAEMPageJSON } from "actions-lib/getAEMPageJSON"

import AppWrapper from "./AppWrapper"

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      getToken,
      getUserPaymentDetails,
      getUserAccountBalance,
      getAllCustomer,
      getLinkedAccounts,
      refreshToken,
      resetUserAccount,
      revokeToken,
      setLastActivityTime,
      setSessionIntervalId,
      setToken,
      getUserDetails,
      setUserDetails,
      setUserState,
      resetCartDetails,
      setSelectedCurrency,
      switchLanguage,
      getGlobalAlerts,
      getAEMPageJSON,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state) => ({
  isBrokerAccount: isBrokerAccountSelector(state),
  authentication: state.authentication,
  customerSelections: state.customerSelections,
  siteLanguage: state.siteLanguage,
  userAccount: state.userAccount,
  userManageAccount: state.userManageAccount,
  myPaymentCheckout: state.myPaymentCheckout,
  aemPageData: state.aemPageData,
})

export default connect(mapStateToProps, mapDispatchToProps)(AppWrapper)
